import React, { useState, useCallback, useEffect } from 'react';
import { Form, Dropdown } from 'semantic-ui-react';
import { producaov2 as api } from '../../../../services/apis';
import { isAuthAdmin } from "../../../../services/auth";
import swal from "sweetalert";

import {
    StyledLabel,
    StyledButton,
    ContainerDouble,
    ContainerSingle
} from './styles';

const Formulario = () => {
    const [evento, setEvento] = useState(null);
    const [eventoSearch, setEventoSearch] = useState('');
    const [eventosOptions, setEventosOptions] = useState('');
    const [inscricoes, setInscricoes] = useState([]);
    const [modeloEmail, setModeloEmail] = useState([]);
    const [alvo, setAlvo] = useState(null);
    const [alvoOptions, setAlvoOptions] = useState('');
    const [modeloCupom, setModeloCupom] = useState([]);

    useEffect(() => {
        loadAuth();

        let options = [
            { key: 0, text: `Usuário Comum - 0`, value: 0 },
            { key: 1, text: `Embaixadores - 1`, value: 1 },
            { key: 2, text: `Movimentos Estudantis - 2`, value: 2 }
        ];

        setAlvoOptions(options);
    }, []);

    const loadAuth = async () => {
        const auth = await isAuthAdmin();

        if (!auth) {
            localStorage.setItem("redirect", `/admin/`);
            window.location.href = "/login";
            return null;
        }
    };

    async function createMarcacoes() {
        let emailsArray = [];

        emailsArray.push({
            id_evento: evento,
            inscricoes: inscricoes,
            modelo_email: modeloEmail,
            parceiro: alvo,
            id_template_cupom: modeloCupom
        });

        const data = {
            emailsArray
        };

        await api
            .post(`/admin/eventos/mail`, data)
            .then(res => {
                swal('Sucesso no cadastro!', 'A marcação foi criada.', 'success');
            })
            .catch(err => {
                console.error(err);
                swal('Erro no cadastro!', 'Aconteceu algum erro durante a criação.', 'error');
            });
    }

    const handleAlvoChange = useCallback((e, { value }) => {
        setAlvo(value);
    }, []);

    const handleEventoChange = useCallback((e, { options, value }) => {
        const text = options.find(option => option.value === value).text;
        setEvento(value);
        setEventoSearch(text);
    }, []);

    const handleEventoSearchChange = useCallback((e) => {
        const search = e.target.value;

        setEventoSearch(search);

        api.get(`/eventos/search/${search}`).then(res => {
            if (res.data) {
                const options = res.data.map((evento, index) => ({
                    key: index, text: `(${evento.titulo}) [ID: ${evento.id}]`, value: evento.id
                }))
                setEventosOptions(options);
                return;
            }
            setEventosOptions([]);
        });
    });

    return (
        <Form>
            <Form.Field>
                <StyledLabel>ID do evento</StyledLabel>
                <Dropdown
                    placeholder="Busque pelo ID ou título do evento"
                    fluid
                    search
                    selection
                    options={eventosOptions}
                    onChange={handleEventoChange}
                    searchQuery={eventoSearch}
                    onSearchChange={handleEventoSearchChange}
                    value={evento}
                />
            </Form.Field>
            <ContainerDouble>
                <ContainerSingle>
                    <Form.Field>
                        <StyledLabel>Número de indicações necessárias</StyledLabel>
                        <Form.Input
                            placeholder='Número de indicações'
                            type="number"
                            value={inscricoes}
                            onChange={e => setInscricoes(e.target.value)}
                        />
                    </Form.Field>
                </ContainerSingle>
                <ContainerSingle>
                    <Form.Field>
                        <StyledLabel>Modelo do e-mail de premiação</StyledLabel>
                        <Form.Input
                            placeholder='Modelo do e-mail'
                            type="number"
                            min="0"
                            value={modeloEmail}
                            onChange={e => setModeloEmail(e.target.value)}
                        />
                    </Form.Field>
                </ContainerSingle>
            </ContainerDouble>
            <ContainerDouble>
                <ContainerSingle>
                    <Form.Field>
                        <StyledLabel>Alvo do e-mail</StyledLabel>
                        <Dropdown
                            placeholder="Usuário comum ou parceiro?"
                            fluid
                            selection
                            options={alvoOptions}
                            onChange={handleAlvoChange}
                            value={alvo}
                        />
                    </Form.Field>
                </ContainerSingle>
                <ContainerSingle>
                    <Form.Field>
                        <StyledLabel>Modelo do cupom de premiação</StyledLabel>
                        <Form.Input
                            placeholder='Modelo do cupom'
                            type="number"
                            min="0"
                            value={modeloCupom}
                            onChange={e => setModeloCupom(e.target.value)}
                        />
                    </Form.Field>
                </ContainerSingle>
            </ContainerDouble>
            <StyledButton onClick={createMarcacoes} >
                <i class="plus icon"></i> Criar Marcação
            </StyledButton>
        </Form>
    );
}

export default Formulario;
